<container kind="midi">
    <page-intro-header back="/subjects" [isAdmin]="isAdmin"
        title="{{ 'SUBJECT_DETAILS.TITLE' | translate }} - {{subject?.firstName}} {{subject?.lastName}}, {{'SUBJECT_DETAILS.REG_BR' | translate }} {{subject?.registrationId === null? '/' : subject?.registrationId }}">
        <span matTooltip="{{'SNACKBAR.ARCHIVE_UNARCHIVE_IMPOSSIBLE' | translate }}"
            [matTooltipDisabled]="subject?.status?.id !== 3">
            <button [disabled]="subject?.status?.id === 3" mat-flat-button color="primary" [matMenuTriggerFor]="menu"
                class="dropdown-button" *ngIf="!isMainCenterBelgrade && !isUserDrugostepeni && !isAdmin">
                {{ 'GLOBAL.MANAGE' | translate }}
                <mat-icon>arrow_drop_down</mat-icon>
            </button>
        </span>
        <mat-menu #menu="matMenu" xPosition="before">
            <span>
                <button *ngIf="!isArchived" mat-menu-item (click)="openDialog('archive', subject)">
                    <mat-icon>archive</mat-icon> {{ 'SUBJECT_DETAILS.ARCHIVE' | translate }}
                </button>
            </span>
            <span>
                <button *ngIf="isArchived && !isArchivedInCsr" mat-menu-item (click)="openDialog('unarchive', subject)">
                    <mat-icon>unarchive</mat-icon> {{ 'SUBJECT_DETAILS.UNARCHIVE' | translate }}
                </button>
            </span>
        </mat-menu>

    </page-intro-header>
    <div *ngIf="subject?.cpsuStatus!=='PASIVE'">
        <h4 class="assigned_dossier__title" *ngIf="subject?.cpsuDossierOwner!==null && subject?.cpsuDossierOwner!==''">
            {{ 'SUBJECT_DETAILS.DOSSIER_OWNER' | translate }}
            {{subject.cpsuDossierOwner}}</h4>
    </div>
    <div *ngIf="subject?.cpsuStatus==='PASIVE'">
        <status-label status="{{2}}">
            {{ 'SUBJECT_DETAILS.DOSSIER_ARCHIVED' | translate }}
        </status-label>
    </div>

    <mat-tab-group (selectedTabChange)="selectTab($event)" animationDuration="0">
        <mat-tab label="{{ 'SUBJECT_DETAILS.TAB_ONE' | translate }}" class="tab-content">
            <subject-cases></subject-cases>
            <subject-problems [cpsuSubjectId]="subject?.cpsuSubjectId" [cpsuCsrId]="subject?.cpsuCsrId"
                [status]="false"></subject-problems>
            <subject-record [cpsuSubjectId]="subject?.cpsuSubjectId" [cpsuCsrId]="subject?.cpsuCsrId"
                [status]="false"></subject-record>
        </mat-tab>
        <mat-tab label="{{ 'SUBJECT_DETAILS.TAB_TWO' | translate }}" class="tab-content">
            <app-cpsu-subject-personal-info [subject]="subject" [familyDossier]="familyDossier"
                [showDivider]="showDivider" [members]="fosterFamilyData"></app-cpsu-subject-personal-info>
        </mat-tab>
        <mat-tab label="{{ 'SUBJECT_DETAILS.TAB_THREE' | translate }}" class="tab-content">
            <app-cpsu-subject-history *ngIf="isSubjectHistoryRendered"></app-cpsu-subject-history>
        </mat-tab>
    </mat-tab-group>
</container>